import { ASC } from 'ycharts/static/ts/constants/core.constants';
import { ChartSortColumn } from 'apps/charts/static/charts/ts/enums/chart-common.enum';
import * as i0 from "@angular/core";
/**
 * Base directive for the Risk Profiles saved-modal wrapper components.
 * Holds column config, filter defaults, and sortable column references that are
 * shared between the multi-select and single-select variants.
 */
export class RiskProfilesSavedModalBaseDirective {
    constructor() {
        this.ChartSortColumn = ChartSortColumn;
        this.SAVED_ITEM_COLUMN_CONFIG = {
            [ChartSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [ChartSortColumn.USER_MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [ChartSortColumn.OWNER]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.SAVED_ITEM_FILTER_DEFAULT = {
            owner: { me: true, shared_with_me: true, public: true },
            page: 1,
            sortColumn: ChartSortColumn.USER_MODIFY_DATE,
            sortDirection: ASC,
            name: '',
            includeEmptyFolders: true,
        };
    }
}
RiskProfilesSavedModalBaseDirective.ɵfac = function RiskProfilesSavedModalBaseDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfilesSavedModalBaseDirective)(); };
RiskProfilesSavedModalBaseDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: RiskProfilesSavedModalBaseDirective });
